// src/hooks/useAnonymousUser.ts

"use client";

import { getAnonymousUserId } from '@/lib/anonymous-user';

// Make it synchronous - no useEffect needed
export function useAnonymousUser() {
    // localStorage is synchronous, so we can call it directly
    const userId = getAnonymousUserId();

    return {
        userId,
        isReady: true  // Always ready since it's synchronous
    };
}